import { SvgIcon, SvgIconProps} from '@mui/material';
import './ccf-elevated-chat-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfElevatedChatIconProps extends SvgIconProps {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfElevatedChatIcon(props: CcfElevatedChatIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M9.77029 0.00154624H5.30458C3.89772 0.00154624 2.54848 0.538543 1.55368 1.4944C0.558875 2.45025 0 3.74666 0 5.09845V5.19049C0 6.54227 0.558875 7.83869 1.55368 8.79454C2.54848 9.7504 3.89772 10.2874 5.30458 10.2874H7.42593L12.0406 13.4164C12.1088 13.464 12.1894 13.4925 12.2735 13.4987C12.3575 13.5049 12.4417 13.4887 12.5168 13.4518C12.5918 13.4148 12.6547 13.3587 12.6986 13.2895C12.7424 13.2203 12.7654 13.1408 12.7651 13.0598L12.0406 9.70646C12.9232 9.2885 13.6674 8.64289 14.19 7.84183C14.7127 7.04076 14.9931 6.11582 15 5.17039V5.07601C14.9944 3.7397 14.4429 2.45894 13.4641 1.50953C12.4854 0.560133 11.1577 0.0180395 9.76707 0L9.77029 0.00154624Z"
        fill="#007AB8"
      />
    </SvgIcon>
  );
}

export default CcfElevatedChatIcon;
